import { useEffect, useLayoutEffect } from "react";
const useIsomorphicLayoutEffect = typeof window === "undefined" ? useEffect : useLayoutEffect;
export {
  useIsomorphicLayoutEffect as default
};
//# sourceMappingURL=useIsomorphicLayoutEffect.es.js.map
